
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CircleCheck, Bot, BrainCircuit } from 'lucide-react';

export const HowItWorksCard = () => {
  return (
    <Card className="mb-6">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">How It Works</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-0 text-sm">
        <div className="flex items-start gap-2">
          <Bot className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <p>Our AI analyzes text patterns, linguistic markers, and semantic coherence.</p>
        </div>
        <div className="flex items-start gap-2">
          <BrainCircuit className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <p>Multiple detection models work together to identify potentially fraudulent or AI-generated content.</p>
        </div>
        <div className="flex items-start gap-2">
          <CircleCheck className="h-5 w-5 text-primary mt-0.5 flex-shrink-0" />
          <p>Higher scores indicate a greater likelihood of non-human or suspicious content.</p>
        </div>
      </CardContent>
    </Card>
  );
};
